module.exports = __webpack_public_path__ + "static/img/nodata.33474417.jpg";